<template lang="pug">
.panel-listing
    .card
      .card-header {{PLANG.globalMyAccount}}
      .card-body
        p.desc {{PLANG.welcomeToAccount}}
        .card.index-links
            ul.list-group.list-group-flush
              li.list-group-item
                a(href="")
                  i.fa.fa-car
                  | {{PLANG.userPanelSellCar}}
              li.list-group-item
                a(href="")
                  i.fa.fa-list-ul
                  | {{PLANG.mangeYourCars}}
              li.list-group-item
                a(href="")
                  i.fa.fa-list-alt
                  | {{PLANG.mySavedList}}
    .card.card-cars.mt-2(v-if="pageData.carsOnSale.length>0")
        .card-header Cars On Sale
        .card-body
          .ad-item.row(v-for="item in pageData.carsOnSale")
            .col-4
              .image
                img(:src="item.showImage")
            .col-8
              .details
                  a
                    h2 {{item.title}}
</template>
<script>
import $ from "jquery";
export default {
  name: 'PanelIndex',
  data() {
    return {
      LANG : window.LANG,
      PLANG : window.PLANG,
      pageData : window.pageData,
    }
  },
  beforeMount: function () {

  },
  methods : {

  }
}
</script>



// WEBPACK FOOTER //
// src/modules/PanelIndex.vue